export const BeforeLoginApartmentStepPageNames = {
  0: 'Before Login Apartment Creation - step/0' as const,
  1: 'Before Login Apartment Creation - step/1' as const,
  2: 'Before Login Apartment Creation - step/2' as const,
  3: 'Before Login Apartment Creation - step/3' as const,
  4: 'Before Login Apartment Creation - step/4' as const,
  5: 'Before Login Apartment Creation - step/5' as const,
  6: 'Before Login Apartment Creation - step/6' as const,
  7: 'Before Login Apartment Creation - step/7' as const,
  8: 'Before Login Apartment Creation - step/8' as const,
  9: 'Before Login Apartment Creation - step/9' as const,
  10: 'Before Login Apartment Creation - step/10' as const,
  11: 'Before Login Apartment Creation - step/11' as const
}

export type ApartmentStepBeforeLogin =
  | typeof BeforeLoginApartmentStepPageNames[0]
  | typeof BeforeLoginApartmentStepPageNames[1]
  | typeof BeforeLoginApartmentStepPageNames[2]
  | typeof BeforeLoginApartmentStepPageNames[3]
  | typeof BeforeLoginApartmentStepPageNames[4]
  | typeof BeforeLoginApartmentStepPageNames[5]
  | typeof BeforeLoginApartmentStepPageNames[6]
  | typeof BeforeLoginApartmentStepPageNames[7]
  | typeof BeforeLoginApartmentStepPageNames[8]
  | typeof BeforeLoginApartmentStepPageNames[9]
  | typeof BeforeLoginApartmentStepPageNames[10]
  | typeof BeforeLoginApartmentStepPageNames[11]
